import feesImage from "../assets/feesandcharges.png";
import "./container.css";
import "./FeesCharges.css";

const ROWS = [
  { name: "Rate of Interest (ROI)", amount: "Up to 15%" },
  { name: "One-Time Consolidation Fee", amount: "10% on loan amount" },
  { name: "Processing Fee (PF)", amount: "10%" },
  { name: "Foreclosure Charges", amount: "4%" },
];

const FeesCharges = () => {
  return (
    <section className="fees-section w-full">
      <div className="container-8xl">
        <div className="fees-grid">
          {/* Left: copy */}
          <div className="fees-left">
            <span
              className="fees-label"
              style={{ color: "#032799", fontWeight: 500, fontStyle: "normal", fontFamily: "Inter" }}
            >
              Pricing Transparency
            </span>
            <img src={feesImage} alt="Fees and charges illustration" className="fees-illustration" />
          </div>

          {/* Right: card */}
          <div className="fees-card">
            <div className="fees-table-header">
              <span>Charge Type</span>
              <span>Amount</span>
            </div>

            <div className="fees-rows">
              {ROWS.map((row) => (
                <div key={row.name} className="fees-row">
                  <span
                    className="fees-row-name"
                    style={{ color: "#030712", fontWeight: 500, fontStyle: "normal", fontFamily: "Inter" }}
                  >
                    {row.name}
                  </span>
                  <span
                    className="fees-row-amount"
                    style={{ color: "#4A3AFF", fontWeight: 600, fontStyle: "normal", fontFamily: "Inter" }}
                  >
                    {row.amount}
                  </span>
                </div>
              ))}
            </div>

            <p
              className="fees-gst-note"
              style={{ color: "#5A5A60", fontFamily: "Inter", fontStyle: "italic", fontWeight: 400 }}
            >
              * All charges mentioned above are exclusive of GST.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeesCharges;
